import { Injectable } from '@angular/core';

import { JsonHttpService } from '../../http/json-http.service';
import { Country } from '../models';

@Injectable({
    providedIn: 'root'
})
export class CountryService {

    constructor(private httpService: JsonHttpService) {
    }

    public getCountries(): Promise<Country[]> {
        return this.httpService.get('/api/iso/country/get-countries').toPromise();
    }
}
